export default "__VITE_ASSET__BQdYTFCI__"